import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IWidgetItem } from '../../interfaces/widget-item.interface';
import { Widget } from '../../decorator/widget.decorator';
import { IdynamicFormItem } from '../../../../app/shared/dynamic-form/interfaces/IdynamicFormItem';
import { get } from 'lodash';

@Component({
  selector: 'ispm-number-of-input',
  templateUrl: './number-of-input.component.html',
  styleUrls: ['./number-of-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget()
export class NumberOfInputComponent implements OnInit, IWidgetItem {
  public data: {
    from?: any
    to?: any
  } = { };

  public formConfig = null;
  set widgetConfig(widgetConfig: IdynamicFormItem) {
    // widgetConfig.widgetPayload.formConfig;
    const widgetPayload = get(widgetConfig, 'widgetPayload', { });
    Object.assign(this, widgetPayload);
    this.formConfig = widgetPayload.formConfig;

  }

  set widgetData(widgetData: any) {
    this.data = widgetData || { };
  }

  widgetUpdateValueCallback: (value) => void;

  constructor() { }

  ngOnInit() {
  }

  onBlur($event) {

    this.widgetUpdateValueCallback(this.data);
  }


}
